<template>
  <div class="container">
    <div class="location" style="margin: 15px 0px 0px 5px">
      <i class="el-icon-location-information" style="font-size: 25px;"></i>
      <span style="font-size: 14px;;">广州市交通技师学院</span>
    </div>
    <!-- <van-notice-bar scrollable text="近期已经帮助人们100例" color="#1989fa" background="#ecf9ff" left-icon="volume-o"
      style="margin-top: 10px" /> -->
    <div class="lunbo" style="margin-top: 15px;">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item><img src="../assets/1.png" alt=""></van-swipe-item>
        <van-swipe-item><img src="../assets/2.png" alt=""></van-swipe-item>
        <van-swipe-item><img src="../assets/3.png" alt=""></van-swipe-item>
        <van-swipe-item><img src="../assets/4.png" alt=""></van-swipe-item>
      </van-swipe>
    </div>
    <!-- <div style="margin-left: 15px; margin-top: 10px; width: 120px;">
      <el-card class="box-card">
        <van-icon name="guide-o" size="3rem"/>
        <el-button type="primary" icon="el-icon-plus" circle size="mini" style="float: right;"></el-button>
        <span style="text-align: center; font-size: 20px; font-weight: bold; color:#498597;" >失物招领</span>
      </el-card>
    </div>
    <div style="width: 120px;">
      <el-card class="box-card">
        <van-icon name="search" size="3rem"/>
        <el-button type="primary" icon="el-icon-plus" circle size="mini" style="float: right;"></el-button>
        <span style="text-align: center; font-size: 20px; font-weight: bold; color:#498597;" >寻物寻事</span>
      </el-card>
    </div> -->
    <div style="display: flex; justify-content: center;">
      <div style="width: 120px; margin-left: 15px; margin-top: 5px;">
        <el-card class="box-card">
          <van-icon name="guide-o" size="3rem" />
          <van-button size="mini" round color="#33c2ff" style="float: right;" to="/Shiwu"><van-icon name="plus"
              size="15" /></van-button>
          <span style="text-align: center; font-size: 20px; font-weight: bold; color:#498597;">失物招领</span>
        </el-card>
      </div>
      <div style="width: 120px; margin-right: 20px; margin-top: 5px; margin-left: 15px;">
        <el-card class="box-card">
          <van-icon name="search" size="3rem" />
          <van-button size="mini" round color="#33c2ff" style="float: right;" to="/Xunwu"><van-icon name="plus"
              size="15" /></van-button>
          <span style="text-align: center; font-size: 20px; font-weight: bold; color:#498597;">寻物寻事</span>
        </el-card>
      </div>
    </div>
    <div class="notice">
      <span style="margin-top: 15px;"><van-icon name="bullhorn-o" size="30" />最新公告</span>
      <el-card class="box-cards">
        <div v-for="(item, index) in items" :key="index" class="text item">
          <span class="bullet"></span>{{ item }}
        </div>
      </el-card>
    </div>
    <el-card class="box-card2" >
      <img src="../assets/logo.png" alt="" style="width: 30%; float: left;">
      <div style="text-align: center;">
        <h4 style="font-weight: bold;">失物小站客服</h4>
        <span @click="onKefu" style="color: red; font-weight: bold;">请点击我，即可进入客服咨询页面</span>
      </div>
    </el-card>
    <div class="footer">
      <van-tabbar v-model="active">
        <van-tabbar-item icon="home-o">首页</van-tabbar-item>
        <van-tabbar-item icon="like-o" to="/Pay">关注</van-tabbar-item>
        <van-tabbar-item icon="comment-o " to="/Hall">大厅</van-tabbar-item>
        <van-tabbar-item icon="manager-o" to="MyLogin">我的</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      active: 0,
      items: [
        "仅三天平台处理100件失物",
        "最近的现金50元已经找到失主",
        "失物小站感谢平台好心人，让世界变得更美好",
        "失物小站感谢平台好心人，让世界变得更美好",
        "失物小站感谢平台好心人，让世界变得更美好",
      ],
    };
  },
  methods: {
    onKefu() {
      this.$router.push('/Customer');
    }
  }
}
</script>

<style scoped>
.my-swipe {
  width: 100%;
}

.my-swipe .van-swipe-item img {
  width: 100%;
}

.box-card {
  width: 100%;
  border-radius: 20%;
}

.box-cards {
  width: 90%;
  margin: 10px auto;
  border-radius: 3%;
}

.box-card2 {
  width: 90%;
  height: 100%;
  margin: 10px auto;
  border-radius: 3%;
}

.text {
  font-size: 12px;
  letter-spacing: 1px;
}

.item {
  padding: 5px 0px;
  font-weight: bold;
}

.list {
  list-style-type: none;
}

.bullet {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: #42ace8;
  border-radius: 50%;
  margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue